<template>
  <div class="list" style="padding: 1.5rem 0.65rem 0.5rem 0.65rem; text-align: left;">
    <table class="table" style="border-collapse:collapse; border:solid windowtext 1.0pt;" rules="all"
      v-if="(0 < totalItems)">
          <thead>
            <tr>
              <th class="th-title" style="width: 2.5em;">序號</th> 
              <th class="th-title" style="width: 15em;">類別</th> 
              <th class="th-title">主題</th> 
              <th class="th-title" style="width: 10em;">學校</th> 
              <th class="th-title" style="width: 10em;">科系</th> 
              <th class="th-title" style="width: 4.75em;"
                v-for="tIdx in docRecordList.tecLen" :key="'T0'+tIdx" :index="tIdx" :name="'T0'+tIdx">
                指導老師{{tIdx}}
              </th> 
              <th class="th-title" style="width: 4.75em;"
                v-for="sIdx in docRecordList.studLen" :key="'S0'+sIdx" :index="sIdx" :name="'S0'+sIdx">
                參賽學生{{sIdx}}
              </th>
            </tr>
          </thead>
            <tbody>
                <tr v-for="(item, index) in docRecordList.data" :key="item.fId" :index="item.fId" :name="item.fId">
                  <td class="td-text" style="text-align: center;">{{index+1}}</td>
                  <td class="td-text">{{item.typeStr}}</td>
                  <td class="td-text">{{item.title}}</td>
                  <td class="td-text">{{item.schName}}</td>
                  <td class="td-text">{{item.division}}</td>
                  <td class="td-text" 
                    v-for="tdIdx in docRecordList.tecLen"
                    :key="'T1'+tdIdx">
                    {{(item.guide.length>=tdIdx? item.guide[tdIdx-1].name:'')}}
                  </td>
                  <td class="td-text"
                    v-for="sdIdx in docRecordList.studLen"
                    :key="'S1'+sdIdx">
                    {{(item.student.length>=sdIdx? item.student[sdIdx-1].name:'')}}
                  </td>
                </tr>
            </tbody>
    </table>
    <div v-else>無相關資料~</div>
  </div>
</template>

<script>
import * as tools from '../tool';
export default {
  name: 'list',
  data () {
    return {
      docRecordList: [],
      totalItems: 0,
      sLen: 0,
      tLen: 0
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
  },
  methods: {
    query() {
      var vm = this;
      this.docRecordList = null;
      this.totalItems = 0;
      this.$http.get('./WebApi/Apply/GetListData/'.concat(this.sysId).concat("/").concat(this.setting.enrollID[0].codeName).concat("/2/1"))
                .then((response) => {
                  if (!tools.isNull(response.data)) { 
                    vm.docRecordList = response.data;
                    vm.totalItems = vm.docRecordList.data.length;
                  }
                })
                .catch(function (error) {
                  vm.$message.error('對不起,網路連線失敗' + error)
                }) 
    }
  },
  created () {
    this.query();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.th-title {
  font-size: smaller;
  text-align: center;
  line-height: 1.75rem;
  font-weight: bold;
}
.td-text {
  line-height: 1.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ListView.vue